const colors = {
  primary: {
    100: "#EFF1FE",
    200: "#828DF9",
    300: "#6371F7",
    400: "#4F5AC6",
    500: "#454FAD",
    alpha: "#EBEDF5",
    10: "rgba(2, 85, 237, 0.1)",
  },
  secondary: {
    100: "#E4F6C8",
    200: "#DBF3B5",
    300: "#A6E247",
    400: "#95CB40",
    500: "#749E32",
    alpha: "#F6FCED",
    10: "rgba(242, 180, 41, 0.1)",
  },
  neutral: {
    50: "#F8F9FA",
    100: "#FFFFFF",
    200: "#E5E5E5",
    300: "#CACACA",
    400: "#B0B0B0",
    500: "#959595",
    600: "#7B7B7B",
    700: "#606060",
    800: "#000000",
    900: "#2B2B2B",
    1000: "#111111",
    10: "rgba(17, 17, 17, 0.1)",
  },
  red: {
    100: "#FB3748",
    200: "#D00416",
    10: "rgba(251, 55, 72, 0.1)",
  },
  yellow: {
    100: "#FFDB43",
    200: "#DFB400",
    10: "rgba(255, 219, 67, 0.1)",
  },
  green: {
    100: "#84EBB4",
    200: "#1FC16B",
    300: "#178F4F",
    10: "rgba(31, 193, 107, 0.1)",
  },
};
export default colors;
